<template>
  <div>
    <iModal title="连麦 " v-model="showModal" class-name="common-ad-add" width="600px" :mask-closable="false" @on-cancel="cancel">
      <div class="admin-add">
        <div class="admin-add-content">
          <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="100" @submit.native.prevent>
            <FormItem required label="连麦人数：" prop="count">
              <Select v-model="formInline.count" style="width:200px">
                <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.label }}</Option>
              </Select>
              <p style="font-size:12px;">不使用连麦则无法创建嘉宾角色</p>
              <Checkbox v-model="formInline.isOpenBlackLive">开启直播回放</Checkbox>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "ad-home-add",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      single: false,
      loading: false,
      showModal: false,
      formInline: {
        count: 0,
        isOpenBlackLive: false,
      },
      ruleInline: {
        // count: [{ required: true, message: '请选择连麦人数', trigger: 'change' }],
      },
      list: [
        {
          value: 0,
          label: "不使用连麦",
        },
        {
          value: 1,
          label: "1v1",
        },
        {
          value: 2,
          label: "1v2",
        },
        {
          value: 3,
          label: "1v3",
        },
        {
          value: 4,
          label: "1v4",
        },
        {
          value: 5,
          label: "1v5",
        },
        {
          value: 6,
          label: "1v6",
        },
      ],
      visible: false,
    };
  },
  watch: {
    show (val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  methods: {
    ...mapActions({
      applyAudit: "liveModule/applyAudit",
    }),
    async handleSubmit (name) {
      if (!this.info) return;
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        activityId: this.info.id,
        audit: 'pass',
        liveWheatNumber: this.formInline.count,
        isOpenBlackLive: this.formInline.isOpenBlackLive,
        auditRemark: '',
      };
      this.loading = true;
      let bool = await this.applyAudit(req).catch(err => {
        this.loading = false;
      });
      this.loading = false;
      if (bool && bool.data && bool.data.live && bool.data.live.audit) {
        this.cancel();
        this.$emit("finish");
        this.$Message.success("操作成功！");
      } else {
        let err = "操作失败，请重新尝试";
        if (bool.errors && bool.errors[0]) {
          err = bool.errors[0].message;
        }
        this.$Message.error(err);
      }
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel () {
      this.formInline.count = "";
      this.$refs["formInline"].resetFields();
      this.formInline.count = 0;
      this.formInline.isOpenBlackLive = false;
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}

.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }

  &-content {
    .submit {
      display: flex;
      justify-content: center;

      button {
        margin-left: -75px;
      }
    }

    img {
      width: 150px;
      height: 150px;
    }
  }

  .form-code-item {
    position: relative;

    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;

      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>
<style lang="scss">
.common-ad-add {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  // IE10+ CSS styles go here
  .common-ad-add {
    display: block;

    .ivu-modal {
      top: 150px;
    }
  }
}
</style>
